// LMS Templates translations for React Admin resource
export const lmsTemplatesResource = {
  name: 'LMS 範本',
  fields: {
    id: 'ID',
    name: '名稱',
    description: '描述',
    type: '類型',
    usage: '使用情況',
    status: '狀態',
    isActive: '啟用',
    isSystem: '系統範本',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    createdBy: '建立者',
    actions: '操作',
    powerUtilizationPercent: '功率使用率',
    minPowerPerCharger: '每個充電樁最小功率',
    powerReductionStep: '功率降低步進',
    roundToNearest: '捨入至最接近',
  },
};

// Custom LMS templates translations for components
export const lmsTemplates = {
  show: {
    title: 'LMS 範本詳情',
    subtitle: '檢視和管理範本配置',
  },
  systemTemplate: '系統範本',
  create: {
    title: '建立 LMS 範本',
    subtitle: '定義新的電力分配範本以進行負載管理',
    backToList: '返回 LMS 範本列表',
  },
  edit: {
    title: '編輯 %{name}',
    subtitle: '修改電力分配設定和配置',
    backToList: '返回 LMS 範本列表',
  },
  tabs: {
    general: '一般資訊',
    danger: '危險區域',
  },
  delete: {
    title: '刪除 LMS 範本',
    content: '此範本將被永久刪除',
    hasLoadGroupsContent: '無法刪除正在被負載組使用的範本',
    warning: '警告：此操作無法復原',
    confirmMessage: '您即將刪除 LMS 範本「%{name}」',
    typeToConfirm: '要確認刪除，請在下方輸入「%{name}」：',
    nameDoesNotMatch: '名稱不匹配',
    button: '刪除範本',
  },
  validation: {
    nameTooLong: '名稱必須少於 100 個字元',
    descriptionTooLong: '描述必須少於 500 個字元',
    utilizationTooLow: '功率使用率必須至少為 50%',
    utilizationTooHigh: '功率使用率不能超過 100%',
    minPowerTooLow: '最小功率必須至少為 3 kW',
    minPowerTooHigh: '最小功率不能超過 22 kW',
    stepTooLow: '降低步進必須至少為 0.1 kW',
    stepTooHigh: '降低步進不能超過 5 kW',
  },
  systemTemplateNote: '系統範本無法修改',
  notInUse: '此範本目前未被任何負載組使用',
  noLoadGroups: '目前沒有負載組使用此範本',
  loadGroups: '個負載組 |||| 個負載組',
  loadGroup: '負載組',
  loadGroupsPlural: '負載組',
  loadGroupsUsing: '使用此範本的負載組',
  affectedLoadGroups: '受影響的負載組',
  types: {
    equal: '平均分配',
    priority: '優先順序',
    scheduled: '排程',
    dynamic: '動態',
  },
  configuration: '配置',
  configExplanation: '此範本使用 %{percent}% 的可用功率，並確保每個充電樁至少獲得 %{min} kW',
  filters: {
    search: '按名稱或描述搜尋',
    activeOnly: '僅啟用',
    systemOnly: '系統範本',
  },
  actions: {
    clone: '複製範本',
    viewAffectedLoadGroups: '查看受影響的負載組',
  },
  sections: {
    basic: '基本資訊',
    configuration: '配置',
    preview: '即時預覽',
    usage: '使用分析',
    analytics: '使用情況與分析',
    metadata: '中繼資料',
    dangerZone: '危險區域',
  },
  helpers: {
    name: '此範本的唯一名稱',
    description: '範本用途的可選描述',
    type: '範本類型決定分配演算法',
    typeCannotChange: '使用中的範本類型無法更改',
    powerUtilizationPercent: '使用總負載組功率的百分比。預留其餘部分作為安全邊際。',
    minPowerPerCharger: '分配前每個充電樁必須接收的最小功率',
    powerReductionStep: '需要時降低功率的步進大小',
    roundToNearest: '將功率值捨入到最接近的增量以獲得更整潔的值',
  },
  equalDistribution: {
    description: '在所有使用中的充電樁之間平均分配可用功率',
  },
  preview: {
    title: '功率分配預覽',
    scenario: '範例場景：',
    totalPower: '總功率',
    utilization: '使用率',
    chargers: '使用中充電樁',
    distribution: '功率分配',
    note: '%{unused} kW (%{percent}%) 保留作為安全邊際',
  },
  warnings: {
    inUse: '此範本目前被 %{count} 個負載組使用',
    inUseWarning: '此範本目前被 %{count} 個負載組使用。任何變更都會影響它們的功率分配。',
    changesWillAffect: '變更將立即影響功率分配',
    highUtilization: '高功率使用率可能觸發斷路器',
  },
  stats: {
    loadGroups: '負載組',
    totalPower: '管理的總功率',
    chargers: '受影響的充電樁',
    totalPowerDesc: '管理的總功率容量',
    chargersDesc: '受影響的充電樁總數',
  },
  notifications: {
    created: 'LMS 範本建立成功',
    updated: 'LMS 範本更新成功',
    deleted: 'LMS 範本刪除成功',
    deleteError: '刪除 LMS 範本時發生錯誤',
    cloned: 'LMS 範本複製成功',
  },
};